module.exports = __webpack_public_path__ + "static/media/ill-alien.cb42647f.svg";